// MEO landmark ads (Phase 1, Step 4-6, 2026-05-01):
// 商業ポストカード CV ダッシュボード用 API クライアント。
// Backend: omikuji-api Step 3-5 (PR #46) で実装、本番反映済み (api SHA 6e5d91d)。
//
// ?from=YYYY-MM-DD&to=YYYY-MM-DD で期間指定。
// auth: ADMIN (全 advertiser) / BUSINESS (自分が advertiser_user_id の items のみ)。

import ApiService from './ApiService';

export default class BusinessDashboardApi extends ApiService {
    fetchSummary(payload: { from: string, to: string }) {
        return this.get('business/dashboard', payload);
    }
}
